import React from 'react';
import firebase from 'firebase';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import Moment from 'moment';

class Payouts extends React.Component {

  state = { user:localStorage.currentUser, type:localStorage.type };

  componentDidMount() {
   this.getItems(); 
  }

  getItems () {
    var itemArray = [];
    var items;

    if(this.state.type === 'user') {
      items = firebase.database().ref('payouts');
      var userKey = localStorage.userKey;
      items.child(userKey).once('value', (data) => {
        var object = data.val();
        for (var key in object) {
          if (object.hasOwnProperty(key)) {
            itemArray.push(object[key]);
          }
        }
        console.log(itemArray)
        this.setState({items:itemArray})
      });
    } else if(this.state.type === 'admin') {
      items = firebase.database().ref('allPayouts');
      items.once('value', (data) => {
        var object = data.val();
        for (var key in object) {
          if (object.hasOwnProperty(key)) {
            itemArray.push(object[key]);
          }
        }
        console.log(itemArray)
        this.setState({items:itemArray})
      });
    }
  }

  accountHolder(cell, row) { return row.source.account_holder_name }
  amount(cell, row) { return '$'+row.amount/100 }
  createdAt(cell, row) { return cell ? Moment(cell*1000).format('Do MMM YY HH:mm') : 'N/A' }

  render()  {

    return (
      <div>
        <BootstrapTable data={this.state.items}   exportCSV={ true } options={ {defaultSortName: 'created', defaultSortOrder: 'desc' } } pagination striped hover>
          <TableHeaderColumn isKey dataField='destination'>Destination</TableHeaderColumn>
          <TableHeaderColumn dataField='amount' dataFormat={this.amount} csvFormat={this.amount}>Amount</TableHeaderColumn>
          <TableHeaderColumn dataField='status'>Status</TableHeaderColumn>
          <TableHeaderColumn dataField='arrival_date' dataFormat={this.createdAt} dataSort>Arrival date</TableHeaderColumn>
          <TableHeaderColumn dataField='created' dataFormat={this.createdAt} dataSort>Created on</TableHeaderColumn>
        </BootstrapTable>
      </div>
    );
  }
}

export default Payouts;


// WEBPACK FOOTER //
// ./src/containers/Payouts.js